import * as yup from 'yup';

import StorePresenter from '../../presenters/StorePresenter';
import { REQUIRED } from '../../forms/errorsText';

export const validationFields = {
  name: yup.string().required(REQUIRED),
  phoneNumber: yup.string().required(REQUIRED),
  email: yup.string().nullable(),
  customerServiceEmail: yup.string().nullable(),
  normalOpeningHour: yup.number().nullable(),
  normalClosingHour: yup.number().nullable(),
  sundayOpeningHour: yup.number().nullable(),
  sundayClosingHour: yup.number().nullable(),
  brandBackgroundUmageUrl: yup.string(),
  brandLogoImageUrl: yup.string(),
  brandLocationMapUrl: yup.string(),
  categoryIds: yup.array(),
  isFeatured: yup.boolean(),
  storeNumber: yup.string(),
  uniqueInState: yup.boolean().required(REQUIRED),
  fastCashEnabled: yup.boolean().required(REQUIRED),
  billingAddress: yup.string().nullable(),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (store) => {
  const categoriesIds = StorePresenter.categories(store).map(
    (category) => category.id
  );

  const initialValues = {
    ...store,
    locationMap: null,
    logoImage: null,
    backgroundImage: null,
    categoryIds: categoriesIds || [],
  };

  return initialValues;
};
